import { child, get, ref } from "firebase/database";
import { DocumentData, QuerySnapshot, collection, doc, getDoc, getDocs, orderBy, query, setDoc, where } from "firebase/firestore";
import { Blog } from "../../../models/Blog";
import { CommentModel } from "../../../models/Comment";
import { database, firestore } from "../../../utils/firebase";
import FakeBlogRepository from "../fakes/FakeBlogRepository";

export class FirebaseBlogRepository extends FakeBlogRepository {

    getBlogs: (categories: string[]) => Promise<Blog[]> = async (categories: string[]) => {
        try {
            const blogsCollectionRef = collection(firestore, 'blogs');
            let blogsCollection: QuerySnapshot<DocumentData, DocumentData>;
            if (categories.length > 0) {
                const blogsCollectionQuery = query(
                    blogsCollectionRef,
                    where("categories", "array-contains-any", categories),
                    orderBy("createdAt", "desc"),
                );
                blogsCollection = await getDocs(blogsCollectionQuery);
            } else {
                blogsCollection = await getDocs(query(
                    blogsCollectionRef,
                    orderBy("createdAt", "desc"),
                ));
            }
            return blogsCollection.docs.map<Blog>((doc) => doc.data() as Blog);
        } catch (error) {
            console.error("Something went wrong when fetching for blogs", error);
        }
        return [];
    }

    getCategories: () => Promise<string[]> = async () => {
        try {
            const categroiesRef = child(ref(database, "blogs"), "categories");
            const categoriesSnap = await get(categroiesRef);
            return categoriesSnap.val();
        } catch (error) {
            console.error("Something went wrong dudring fetching categories list");
        }
        return [];
    }

    addComment: (blogId: string, comment: CommentModel) => Promise<CommentModel> = async (blogId, comment) => {
        try {
            const commentDoc = doc(collection(firestore, `comments`));
            comment.id = commentDoc.id;
            comment.blogId = blogId;
            await setDoc(commentDoc, comment)
        } catch (error) {
            console.error(error);
        }
        return comment;
    }

    getComments: (blogId: string) => Promise<CommentModel[]> = async (blogId) => {
        try {
            const commentsQuery = query(
                collection(firestore, `comments`),
                where("blogId", "==", blogId),
                orderBy("createdAt", "desc")
            );
            const commentsCollection = await getDocs(commentsQuery);
            return commentsCollection.docs.map<CommentModel>((data) => {
                return { ...data.data() as CommentModel }
            });
        } catch (error) {
            console.error(error);
            return []
        }
    }

    getBlog: (id: string) => Promise<Blog> = async (id) => {
        const blogDocRef = doc(firestore, `blogs/${id}`);
        let blogDoc = await getDoc(blogDocRef);
        if (!blogDoc.exists()) {
            throw new Error('BLOG_NOT_FOUND')
        }
        const comments = await this.getComments(id);
        let blog: Blog = blogDoc.data() as Blog;
        blog.comments = comments;
        return blog;
    }
}